// <Default> spinner is margin 0 to center of component
// Option: <Toolbar> is margin to right of tool bar
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

import { capitalize } from 'store/utility';

import styles from './Spinner.module.css';

class Spinner extends Component {
  render() {
    return (
      <div className={styles[capitalize(this.props.type)]}>
        <Spin size={this.props.size} />
      </div>
    );
  }
}

Spinner.defaultProps = {
  type: 'Default',
  size: 'small',
};

Spinner.propType = {
  type: PropTypes.oneOf(['Default', 'Toolbar']).isRequired,
  size: PropTypes.oneOf(['small', 'large']).isRequired,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js